import {
  LazyLogin,
  LazyDashboard,
  LazyShuttleTrips,
  LazyPrivateTrips,
  LazyDepartments,
  LazyDriversData,
  LazyLittleStaff,
  LazyAddDepartment,
  LazyDriverData,
  LazyShuttleStops,
  LazyEditDriver,
  LazyShuttleDrivers,
  LazyShiftCreation,
  LazyShifts,
  LazyStaff,
  LazyAdmins,
  LazyTrips,
  LazySupport,
  LazyRoutes,
  LazyStops,
  LazyDocumentsUpload,
  LazyDriverList,
  LazyBooking,
  LazyScheduleTrips,
  LazyPreviousBookings,
  LazyBookingDetails,
  LazyBookings,
  LazyNewBooking,
  LazyQrCode,
  LazySettings,
  LazyNewRegistration,
  LazyAddPricingStructure,
  LazyAddNewTasks,
  LazyCorporateRecords,
  LazyTestRouteInfo,
  LazyStopInfo,
  LazyTestStopInfo,
  LazyTripDetails
} from "../utils/lazyComponents";



const authRoutes = [
  { path: "/dashboard", component: LazyDashboard },
  { path: "/shuttle/trips", component: LazyShuttleTrips },
  { path: "/privatedrive/trips", component: LazyPrivateTrips },
  { path: "/live-tracking", component: LazyDriversData },
  { path: "/little-staff", component: LazyLittleStaff },
  { path: "/departments/add-new", component: LazyAddDepartment },
  { path: "/departments", component: LazyDepartments },
  { path: "/privatedrive/livemap", component: LazyDriverData },
  { path: "/shuttle/stops", component: LazyShuttleStops },
  { path: "/privatedrive/drivers", component: LazyEditDriver },
  { path: "/shuttle/drivers", component: LazyShuttleDrivers },
  { path: "/privatedrive/shift-creation", component: LazyShiftCreation },
  { path: "/privatedrive/shifts", component: LazyShifts },
  { path: "/edit", component: LazyAddDepartment },
  { path: "/staffs", component: LazyStaff },
  { path: "/admins", component: LazyAdmins },
  { path: "/trips/:tripId", component: LazyTripDetails },
  { path: "/trips", component: LazyTrips},
  { path: "/support", component: LazySupport },
  { path: "/routes", component: LazyRoutes },
  { path: "/routes/:routeId", component: LazyStops},
  { path: "/addroute", component: LazyTestRouteInfo},
  { path: "/addroute-stop", component: LazyTestStopInfo},

  { path: "/documents", component: LazyDocumentsUpload},
  { path: "/schedule-booking/new booking", component: LazyBooking},
  { path: "/schedule-booking/trips", component: LazyScheduleTrips},
  { path: "/schedule-booking/bookings", component: LazyPreviousBookings},
  { path: "/schedule-booking/previous bookings/details", component: LazyBookingDetails},
  { path: "/shuttle/bookings", component: LazyBookings},
  { path: "/shuttle/new-booking", component: LazyNewBooking},
  { path: "/drivers/:emailId", component: LazyQrCode},
  { path: "/drivers", component: LazyDriverList},
  { path: "/settings", component: LazySettings},
  { path: "/new-registration", component: LazyNewRegistration},
  { path: "/addpricing", component: LazyAddPricingStructure},
  { path: "/corporates", component: LazyCorporateRecords},
  



];
const publicRoutes = [{ path: "/login", component: LazyLogin }];

// const superAdminRoutes=[{path: '/new-registration', component: NewRegistration}]

export { authRoutes, publicRoutes };
